module.exports = __webpack_public_path__ + "static/media/painters-palette.0590a885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/painters-palette.jpg
// module id = 312
// module chunks = 0